import { ApiService } from '@/api/services/core/ApiService';
import { axiosExternalInstance } from '@/api/axios';

export class ExternalService extends ApiService {
  public postRegistrationRequest(body: any) {
    return axiosExternalInstance.post<any>(
      '/api/external/taxpayers/PostRegistrationRequest',
      body,
    );
  }

  public getRegistrationStatusRequest(id: string) {
    return axiosExternalInstance.get<any>(
      '/api/external/taxpayers/GetRegistrationStatusRequest?id=' + id,
    );
  }

  public postPeIncomeRequest(body: any) {
    return axiosExternalInstance.post<any>(
      '/api/external/platformEmp/PostPeIncomeRequest',
      body,
    );
  }

  public postPeCancelReceiptRequest(body: any) {
    return axiosExternalInstance.post<any>(
      '/api/external/platformEmp/PostPeCancelReceiptRequest',
      body,
    );
  }

  public GetPePaymentDocumentsRequest() {
    return axiosExternalInstance.post<any>(
      '/api/external/platformEmp/GetPePaymentDocumentsRequest',
      {},
    );
  }

  public PostPePaymentInfoRequest(body: any) {
    return axiosExternalInstance.post<any>(
      '/api/external/platformEmp/PostPePaymentInfoRequest',
      body,
    );
  }
}
